import { FunctionComponent, useEffect, useRef, useState } from 'react'
import useStyles from './styles'
import { LayoutActionBarProps } from './types'
import { Button, Grid, Space, Stack } from '@conexasaude/conexa-hero'
import useBreakpoints from '@/utils/useBreakpoints'
import { RenderIf } from '@/components/RenderIf'

export const LayoutActionBar: FunctionComponent<LayoutActionBarProps> = ({
  primaryActionLabel,
  secondaryActionLabel,
  negativeActionLabel,
  primaryActionProps,
  secondaryActionProps,
  negativeActionProps,
  primaryAction,
  secondaryAction,
  negativeAction,
  hasPrimaryAction,
  hasSecondaryAction,
  hasNegativeAction,
  customContent,
  styles,
}) => {
  const { isPhone } = useBreakpoints()
  const [footerSize, setFooterSize] = useState<number>(undefined)
  const defaultStyles = useStyles({ footerSize })
  const layoutActionBarRef = useRef(null)

  const updateFooterSize = () => {
    if (layoutActionBarRef.current) {
      setFooterSize(layoutActionBarRef.current.clientHeight)
    }
  }

  useEffect(() => {
    updateFooterSize()
  }, [isPhone])

  return (
    <div css={defaultStyles.root} style={styles?.root} ref={layoutActionBarRef}>
      <div css={defaultStyles.container} style={styles?.body}>
        {!isPhone ? (
          <Grid gutter={0} align="center" justify="space-between">
            <Grid.Col span={4}>
              <RenderIf condition={hasSecondaryAction}>
                <Button
                  onClick={secondaryAction}
                  variant="secondary"
                  {...secondaryActionProps}
                >
                  {secondaryActionLabel}
                </Button>
              </RenderIf>
            </Grid.Col>

            <Grid.Col span={8}>
              <Grid justify="end" gutter={0}>
                <RenderIf condition={hasNegativeAction}>
                  <Button
                    variant="tertiary"
                    onClick={negativeAction}
                    {...negativeActionProps}
                  >
                    {negativeActionLabel}
                  </Button>
                </RenderIf>

                <RenderIf condition={hasNegativeAction && hasPrimaryAction}>
                  <Space w="md" />
                </RenderIf>

                <RenderIf condition={hasPrimaryAction}>
                  <Button onClick={primaryAction} {...primaryActionProps}>
                    {primaryActionLabel}
                  </Button>
                </RenderIf>
              </Grid>
            </Grid.Col>
          </Grid>
        ) : (
          <Stack>
            <RenderIf condition={hasPrimaryAction}>
              <Button onClick={primaryAction} fullWidth {...primaryActionProps}>
                {primaryActionLabel}
              </Button>
            </RenderIf>

            <RenderIf condition={hasSecondaryAction}>
              <Button
                variant="secondary"
                onClick={secondaryAction}
                fullWidth
                {...secondaryActionProps}
              >
                {secondaryActionLabel}
              </Button>
            </RenderIf>

            <RenderIf condition={hasNegativeAction}>
              <Button
                variant="tertiary"
                onClick={negativeAction}
                fullWidth
                {...negativeActionProps}
              >
                {negativeActionLabel}
              </Button>
            </RenderIf>
          </Stack>
        )}
        {customContent}
      </div>
    </div>
  )
}
